import { ProjectViewModel } from "../../../../../../ViewModel/ProjectViewModel";
import { LtlPipelineViewModel } from "../../../../../../ViewModel/LtlPipelineViewModel";
import { isFirstLtlRoute } from "./IsFirstLtlRoute";
import { getStartDestinationGsdb } from "./GetStartDestinationGsdb";
import { formatTimespan } from "./FormatTimespan";
import { getCurrentStartDepartureTime } from "./GetCurrentStartDepartureTime";

export function getQuery(
  project: ProjectViewModel,
  ltlPipeline: LtlPipelineViewModel
) {
  return {
    projectStartDateString: project.StartDateDisplay,

    containerNetwork: ltlPipeline.ContainerNetwork,
    supplierGsdb: ltlPipeline.SupplierGsdb,
    plantGsdb: ltlPipeline.PlantGsdb,
    dockCode: ltlPipeline.DockCode,

    isFirstLtlRoute: isFirstLtlRoute(ltlPipeline),
    startDestinationGsdb: getStartDestinationGsdb(ltlPipeline),
    startDepartureTime: formatTimespan(
      getCurrentStartDepartureTime(ltlPipeline)
    ),
  };
}
